/** X-axis horizons *longer than* this pause live scrolling (SQLite keeps collecting). 1h stays live. */
export const CHART_HISTORICAL_MIN_MS = 60 * 60 * 1000;

/** Auto-refresh interval for historical chart ranges. */
export const CHART_HISTORICAL_REFRESH_MS = 60 * 1000;

export function isHistoricalChartRange(rangeMs: number | null | undefined): boolean {
  if (rangeMs == null) return true;
  return rangeMs > CHART_HISTORICAL_MIN_MS;
}

export function regionalMinutesToMs(minutes: number): number {
  return minutes * 60 * 1000;
}
